export const _en = {
    addButton: {
        label: "Add a resource group"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    modal: {
        add: {
            title: "Add a resource group"
        }
    }

};


export const _fr = {
    addButton: {
        label: "Groupe de ressource"
    },
    toggleDeleted: {
        label: "Afficher les données archivées"
    },
    modal: {
        add: {
            title: "Ajout d'un groupe de ressource"
        }
    }
};